import 'reflect-metadata';
import {Container} from 'inversify';
import {
    AuthService,
    HttpClientService,
    FirebaseService,
    SymbolsService,
    SpreadsheetsService,
    FinancialsService,
    ScreenerService,
    LepriconService, StorageService, I18nService,
} from './services';

const DiContainer = new Container();
DiContainer.bind(FirebaseService).toSelf().inSingletonScope();
DiContainer.bind(HttpClientService).toSelf().inSingletonScope();
DiContainer.bind(AuthService).toSelf().inSingletonScope();
DiContainer.bind(SymbolsService).toSelf().inSingletonScope();
DiContainer.bind(SpreadsheetsService).toSelf().inSingletonScope();
DiContainer.bind(FinancialsService).toSelf().inSingletonScope();
DiContainer.bind(ScreenerService).toSelf().inSingletonScope();
DiContainer.bind(LepriconService).toSelf().inSingletonScope();
DiContainer.bind(StorageService).toSelf().inSingletonScope();
DiContainer.bind(I18nService).toSelf().inSingletonScope();
export {DiContainer as DI};
